<template>
    <div class="auth-menu">
        <lang-switch></lang-switch>
        <template v-if="isShowLoginBtn">
            <div class="home-btn login-btn" @click="onLogin" v-if="!isLogin">{{ $getConfigText(loginInfo.loginBtnName) }}</div>
            <div class="home-btn primary" @click="onRegister" v-if="!isLogin">{{ $getConfigText(loginInfo.registerBtnName) }}</div>
        </template>
        <user-menu v-if="isLogin" :routes="routes"></user-menu>
    </div>
</template>

<style lang="scss" scoped>
.auth-menu{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
}
.home-btn:nth-child(1),
.home-btn:nth-child(2){
    margin-right: 14px;
}
.login-btn{
    background: #fff;
    color: var(--theme);
}
</style>

<script>
import { mapGetters, mapState } from 'vuex'
import { User } from '@/lib/user'
import { Login } from '@/models/login'
import LangSwitch from './lang-switch.vue'
import UserMenu from './user-menu.vue'
export default {
    props: {
        routes: Object
    },
    data() {
        return {
            isLogin: false
        }
    },
    computed: {
        ...mapGetters(['isShowLoginBtn']),
        ...mapState(['loginInfo'])
    },
    components: {
        LangSwitch,
        UserMenu
    },
    created(){
        this.init()
    },
    methods: {
        init(){
            this.isLogin = User.isLogin()
        },
        onLogin(){
            window.location.href = this.loginInfo.loginUrl || `${ Login.getLoginPrefix() }#/commonLogin`
        },
        onRegister(){
            window.location.href = this.loginInfo.registerUrl || `${ Login.getLoginPrefix() }#/commonRegister`
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/header/auth-menu/index.vue